import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { SITE } from "../../config/site";

export default function FloatingContact() {
  const { t } = useTranslation();
  return (
    <div className="float-contact">
      <a className="wa" href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <FaWhatsapp />
        <span className="lbl">{t("floating.whatsapp")}</span>
      </a>
      <a className="mail" href={`mailto:${SITE.email}`} aria-label={t("floating.mail")}>
        <FiMail />
        <span className="lbl">{t("floating.mail")}</span>
      </a>
    </div>
  );
}
